import type { FC } from "react";
import { Icon } from "../../primitives/Icon";
import { PortaledTooltip } from "../../ui/Tooltip";
import { ClassificationPendingSparkle } from "./ClassificationPendingSparkle";

const CLASSIFICATION_FAILED_TOOLTIP = "We couldn't classify this document automatically";
const CLASSIFICATION_PENDING_TOOLTIP = "Analyzing file...";
const CLASSIFICATION_AWAITING_REVIEW_TOOLTIP = "File types suggested by automated analysis";

export type ClassificationFailedIndicatorProps = { rowId: string };

export const ClassificationFailedIndicator: FC<ClassificationFailedIndicatorProps> = ({
	rowId,
}) => {
	const tooltipId = `uploaded-doc-classification-failed-${rowId}`;
	return (
		<>
			<span
				data-tooltip-id={tooltipId}
				data-tooltip-content={CLASSIFICATION_FAILED_TOOLTIP}
				aria-label={CLASSIFICATION_FAILED_TOOLTIP}
				data-testid="classification-failed-indicator"
				className="inline-flex items-center"
			>
				<Icon type="exclamation-triangle" size="mini" color="warning" className="shrink-0" />
			</span>
			<PortaledTooltip id={tooltipId} />
		</>
	);
};

export type ClassificationPendingIndicatorProps = { rowId: string };

export const ClassificationPendingIndicator: FC<ClassificationPendingIndicatorProps> = ({
	rowId,
}) => {
	const tooltipId = `uploaded-doc-classification-pending-${rowId}`;
	return (
		<>
			<span
				data-tooltip-id={tooltipId}
				data-tooltip-content={CLASSIFICATION_PENDING_TOOLTIP}
				aria-label={CLASSIFICATION_PENDING_TOOLTIP}
				data-testid="classification-pending-indicator"
				className="inline-flex items-center"
			>
				<ClassificationPendingSparkle />
			</span>
			<PortaledTooltip id={tooltipId} />
		</>
	);
};

export type ClassificationAwaitingReviewIndicatorProps = { rowId: string };

export const ClassificationAwaitingReviewIndicator: FC<
	ClassificationAwaitingReviewIndicatorProps
> = ({ rowId }) => {
	const tooltipId = `uploaded-doc-classification-awaiting-review-${rowId}`;
	return (
		<>
			<span
				data-tooltip-id={tooltipId}
				data-tooltip-content={CLASSIFICATION_AWAITING_REVIEW_TOOLTIP}
				aria-label={CLASSIFICATION_AWAITING_REVIEW_TOOLTIP}
				data-testid="classification-awaiting-review-indicator"
				className="inline-flex items-center"
			>
				<ClassificationPendingSparkle animated={false} />
			</span>
			<PortaledTooltip id={tooltipId} />
		</>
	);
};
